import React__default from 'react';

var NvTabPanel = function (_a) {
    var tabId = _a.tabId, children = _a.children, show = _a.show;
    if (!show)
        return null;
    return (React__default.createElement("div", { id: tabId, role: "tabpanel" }, children));
};

export { NvTabPanel };
//# sourceMappingURL=NvTabPanel.esm.js.map
